import {
    SET_SCHOOL_APPOINTMENT_ID,
    SET_SCHOOL_DATE,
    SET_SCHOOL_TIME,
    SET_SCHOOL_SESSIONS_PER_WEEK,
    SET_SCHOOL_SESSION_TYPE,
    SET_SCHOOL_REPEAT,
    SET_SCHOOL_SUBJECT_ID,
    SET_SCHOOL_APPOINTMENT_TYPE,
    SET_SCHOOL_JOB_VALUE,
    SET_SCHOOL_SELECTED_STUDENT ,
    SCHOOL_RESET_APPOINTMENT_STATE,
    SET_SCHOOL_DURATION
  } from './schoolPresetValuesTypes';
  
  export const setSchoolAppointmentId = (id) => ({
    type: SET_SCHOOL_APPOINTMENT_ID,
    payload: id
  });
  
  export const setSchoolDate = (date) => ({
    type: SET_SCHOOL_DATE,
    payload: date
  });
  
  export const setSchoolTime = (time) => ({
    type: SET_SCHOOL_TIME,
    payload: time
  });
  
  export const setSchoolSessionsPerWeek = (count) => ({
    type: SET_SCHOOL_SESSIONS_PER_WEEK,
    payload: count
  });
  
  export const setSchoolSessionType = (sessionType) => ({
    type: SET_SCHOOL_SESSION_TYPE,
    payload: sessionType
  });
  
  export const setSchoolRepeat = (repeat) => ({
    type: SET_SCHOOL_REPEAT,
    payload: repeat
  });
  
  export const setSchoolSubjectId = (subjectId) => ({
    type: SET_SCHOOL_SUBJECT_ID,
    payload: subjectId
  });
  
  export const setSchoolAppointmentType = (appointmentType) => ({
    type: SET_SCHOOL_APPOINTMENT_TYPE,
    payload: appointmentType
  });
  
  export const setSchoolJobValue = (jobValue) => ({
    type: SET_SCHOOL_JOB_VALUE,
    payload: jobValue
  });


export const setSchoolSelectedStudent = (student) => ({
    type: SET_SCHOOL_SELECTED_STUDENT,
    payload: student
  });

  export const resetSchoolAppointmentState = () => ({
  type: SCHOOL_RESET_APPOINTMENT_STATE,
});


export const setSchoolDuration = (duration) => {
  return {
    type: SET_SCHOOL_DURATION,
    payload: duration
  };
};